import Vue from "vue";
import Vuetify from "vuetify";
import zhHans from "vuetify/es5/locale/zh-Hans"; // 引入中文语言包
import "@mdi/font/css/materialdesignicons.css"; // 引入本地的Material Design Icons资源
Vue.use(Vuetify);

const opts = {
  theme: { disable: true },
  lang: {
    locales: { zhHans },
    current: "zhHans"
  },
  icons: {
    iconfont: "mdi" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
};

export default new Vuetify(opts);
